import { render, staticRenderFns } from "./MyBalance.vue?vue&type=template&id=51b78c05&scoped=true"
import script from "./MyBalance.vue?vue&type=script&lang=js"
export * from "./MyBalance.vue?vue&type=script&lang=js"
import style0 from "./MyBalance.vue?vue&type=style&index=0&id=51b78c05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b78c05",
  null
  
)

export default component.exports